/* CampVale — top announcement bar
   Single source of truth for the bar shown on every marketing page.
   Edit MESSAGES below and every page updates at once.

   Layout notes:
   · 34px tall, sits in normal flow at the top of <body>, so it scrolls away
     and the sticky site nav takes over the top edge.
   · Pages whose #sitenav is position:fixed (product) get their nav offset
     driven from here so the nav never covers the bar.
*/
(function () {
  var BAR_H = 34;
  var BG = '#23476E';                 // CampVale deep brand blue
  var ROTATE_MS = 4500;

  // The underlined span in each line is a link — same wording style as the rest of the site.
  var MESSAGES = [
    'The <a href="/products/rv-01-smart-light" data-ann-link>RV-01</a> is in stock and ships free worldwide.',
    'Thirty days to try it on your rig. <a href="/pages/returns-refunds" data-ann-link>Free returns</a> either way.',
    'Every RV-01 comes with a <a href="/pages/support" data-ann-link>one-year warranty</a>.'
  ];

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function chevron(dir) {
    var d = dir === 'prev' ? 'M6.5 1L1.5 8l5 7' : 'M1.5 1l5 7-5 7';
    return '<svg width="7" height="16" viewBox="0 0 8 16" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="' + d + '" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function build() {
    if (document.getElementById('cv-annbar')) return;

    var css = document.createElement('style');
    css.textContent =
      '#cv-annbar{position:relative;z-index:60;height:' + BAR_H + 'px;background:' + BG + ';color:#FFFFFF;' +
        'font-family:Archivo,sans-serif;font-size:13px;font-weight:400;line-height:18.2px;letter-spacing:-0.13px;' +
        'display:flex;align-items:center;justify-content:center;overflow:hidden;}' +
      '#cv-annbar .cv-ann-track{position:relative;flex:0 1 auto;height:18px;min-width:0;}' +
      '#cv-annbar .cv-ann-msg{position:absolute;left:50%;top:0;transform:translateX(-50%);white-space:nowrap;' +
        'opacity:0;visibility:hidden;transition:opacity .38s ease;}' +
      '#cv-annbar .cv-ann-msg[data-on="1"]{opacity:1;visibility:visible;}' +
      '#cv-annbar a[data-ann-link]{color:inherit;text-decoration:underline;text-underline-offset:3px;' +
        'text-decoration-thickness:1px;}' +
      '#cv-annbar a[data-ann-link]:hover{color:#FFFFFF;text-decoration-thickness:1.5px;}' +
      '#cv-annbar .cv-ann-arrow{flex:none;background:none;border:0;padding:0 8px;margin:0;cursor:pointer;color:#FFFFFF;' +
        'opacity:.72;display:flex;align-items:center;height:100%;transition:opacity .2s ease;}' +
      '#cv-annbar .cv-ann-arrow:hover{opacity:1;}' +
      '#cv-annbar .cv-ann-arrow:focus-visible{outline:1px solid rgba(255,255,255,.7);outline-offset:-2px;}' +
      '@media (max-width:640px){#cv-annbar .cv-ann-arrow{padding:0 6px;}}' +
      /* Nav links get the same slide-in underline as the footer links.
         currentColor keeps it working on home, where JS flips the link
         colour between light-on-hero and dark-on-white. */
      '#navlinks a{background-image:linear-gradient(currentColor,currentColor);background-repeat:no-repeat;' +
        'background-position:0 100%;background-size:0% 1px;transition:background-size .32s cubic-bezier(.32,.72,.24,1),color .2s ease;}' +
      '#navlinks a:hover{background-size:100% 1px;}' +
      (reduced ? '#cv-annbar .cv-ann-msg{transition:none;}#navlinks a{transition:none;}' : '');
    document.head.appendChild(css);

    var bar = document.createElement('div');
    bar.id = 'cv-annbar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Announcements');

    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'cv-ann-arrow';
    prev.setAttribute('aria-label', 'Previous announcement');
    prev.innerHTML = chevron('prev');

    var next = document.createElement('button');
    next.type = 'button'; next.className = 'cv-ann-arrow';
    next.setAttribute('aria-label', 'Next announcement');
    next.innerHTML = chevron('next');

    var track = document.createElement('div');
    track.className = 'cv-ann-track';
    track.setAttribute('aria-live', 'polite');

    var slides = MESSAGES.map(function (html, i) {
      var s = document.createElement('span');
      s.className = 'cv-ann-msg';
      s.innerHTML = html;
      if (i === 0) s.setAttribute('data-on', '1');
      track.appendChild(s);
      return s;
    });

    bar.appendChild(prev); bar.appendChild(track); bar.appendChild(next);
    document.body.insertBefore(bar, document.body.firstChild);

    // Every line stays on one row (Thuma keeps the bar exactly one line tall), so
    // on narrow screens the type steps down until the longest line fits. Measuring
    // the widest line also stops the arrows from shifting as messages change.
    var BASE_FS = 13, MIN_FS = 10;
    function widestLine() {
      var w = 0;
      slides.forEach(function (s) {
        var vis = s.getAttribute('data-on');
        s.setAttribute('data-on', '1');
        w = Math.max(w, s.getBoundingClientRect().width);
        if (!vis) s.removeAttribute('data-on');
      });
      return w;
    }
    function sizeTrack() {
      track.style.width = 'auto';
      var room = bar.clientWidth
        - prev.getBoundingClientRect().width
        - next.getBoundingClientRect().width
        - 8;                                    // small breathing room
      var fs = BASE_FS;
      bar.style.fontSize = fs + 'px';
      var w = widestLine();
      while (w > room && fs > MIN_FS) {
        fs -= 0.5;
        bar.style.fontSize = fs + 'px';
        w = widestLine();
      }
      track.style.width = Math.ceil(Math.min(w, room)) + 'px';
    }

    var idx = 0, timer = null;
    function show(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        if (i === idx) s.setAttribute('data-on', '1'); else s.removeAttribute('data-on');
      });
    }
    function play() { stop(); if (!reduced) timer = setInterval(function () { show(idx + 1); }, ROTATE_MS); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    prev.addEventListener('click', function () { show(idx - 1); play(); });
    next.addEventListener('click', function () { show(idx + 1); play(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', play);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });

    // Only rotate while the bar is actually on screen — once it scrolls away
    // there is nothing to animate, and the page can settle.
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        entries[0].isIntersecting ? play() : stop();
      }, { threshold: 0 }).observe(bar);
    }

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeTrack);
    sizeTrack();
    window.addEventListener('resize', sizeTrack, { passive: true });
    play();

    holdNav();
  }

  /* Pages whose nav ships as position:fixed (product) are converted to sticky
     so the bar and the nav travel together during elastic overscroll —
     a fixed nav stays pinned while the in-flow bar rubber-bands down,
     visibly detaching the two. Sticky sits at y=34 in flow (right under the
     bar), pins to top:0 once the bar scrolls away, and moves with the page
     during overscroll — same behaviour as every other page's nav.
     The nav is re-checked briefly: on component-rendered pages it does not
     exist yet at DOMContentLoaded, so a one-shot check would miss it. */
  function holdNav() {
    function fix() {
      var nav = document.getElementById('sitenav');
      if (!nav) return false;
      if (getComputedStyle(nav).position === 'fixed') {
        nav.style.position = 'sticky';
        nav.style.top = '0';
        nav.style.left = '';
        nav.style.right = '';
        var sp = document.getElementById('nav-spacer');
        if (sp) sp.style.display = 'none';   // sticky nav occupies flow height itself
      }
      return true;
    }
    if (fix()) return;
    var tries = 0, iv = setInterval(function () { if (fix() || ++tries > 40) clearInterval(iv); }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();

// ---- footer payment icons (Stripe: Visa/MC/Amex + Apple Pay / Google Pay) ----
(function () {
  function addPay() {
    var f = document.getElementById('sitefooter');
    if (!f || document.getElementById('cv-payrow')) return;
    var row = document.createElement('div');
    row.id = 'cv-payrow';
    row.style.cssText = 'max-width:1200px;margin:0 auto;padding:24px 28px 34px;border-top:1px solid rgba(255,255,255,0.08);display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;';
    var src = document.getElementById('cv-pay-src');
    if (!src || !src.querySelector('svg')) return;
    row.innerHTML = "<div style='color:#8A8B92;font:400 12.5px Archivo,sans-serif;letter-spacing:0.4px;'>Secure checkout</div>" +
      "<div data-payicons style='display:flex;gap:8px;align-items:center;flex-wrap:wrap;'></div>";
    var box = row.querySelector('[data-payicons]');
    box.innerHTML = src.innerHTML;
    Array.prototype.forEach.call(box.querySelectorAll('svg'), function (s) {
      s.style.height = '24px'; s.style.width = 'auto'; s.style.display = 'block'; s.style.borderRadius = '3px';
    });
    f.appendChild(row);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addPay); else addPay();
})();

// ---- support page: wire the contact form to Support@campvale.com ----
(function () {
  function initSupport() {
    var send = document.getElementById('sp-send');
    if (!send || send.getAttribute('data-cv-bound')) return;
    send.setAttribute('data-cv-bound', '1');
    var name = document.querySelector('input[aria-label="Your name"]');
    var topic = document.querySelector('input[aria-label="What can we help with?"]');
    var email = document.querySelector('input[aria-label="Your email"]');
    send.addEventListener('click', function () {
      var sub = 'Support request' + (name && name.value ? ' from ' + name.value : '');
      var body = (topic && topic.value ? 'Topic: ' + topic.value + '\n' : '') +
                 (email && email.value ? 'Reply to: ' + email.value + '\n' : '') + '\n';
      window.location.href = 'mailto:Support@campvale.com?subject=' + encodeURIComponent(sub) + '&body=' + encodeURIComponent(body);
    });
    var rep = Array.prototype.filter.call(document.querySelectorAll('div,p'), function (e) {
      return e.children.length === 0 && /We reply within one business day/.test(e.textContent);
    })[0];
    var hint = document.createElement('div');
    hint.style.cssText = 'text-align:center;color:#9A9AA0;font:400 13.5px Archivo,sans-serif;margin-top:10px;';
    hint.innerHTML = 'Or email us directly at <a href="mailto:Support@campvale.com" style="color:#33608D;">Support@campvale.com</a>';
    if (rep && rep.parentNode) rep.parentNode.insertBefore(hint, rep.nextSibling);
    else send.parentElement.parentElement.appendChild(hint);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSupport); else initSupport();
})();

// ---- Chrome scroll-smoothness: promote animated/blurred elements to GPU layers (no visual change) ----
(function () {
  var st = document.createElement('style');
  st.textContent = '#sitenav{will-change:transform;}' +
    '#rv01-pin,#hero-sheet,#prefooter{transform:translateZ(0);}' +
    '#seq-img{will-change:transform;transform:translateZ(0);}' +
    '[data-fc]{will-change:transform,opacity;}';
  document.head.appendChild(st);
})();

// ---- legacy-browser layout fallbacks (@supports not: only browsers missing modern CSS read these) ----
(function () {
  var st = document.createElement('style');
  st.textContent =
    '@supports not (height: 1svh) {' +
      'div[style*="aspect-ratio:"]{aspect-ratio:auto !important;}' +
      '[data-cvs-step]{height:100vh !important;}' +
      '#fn-mobile{min-height:100vh !important;}' +
      '#fn-mobile > div{min-height:100vh !important;}' +
    '}' +
    '@supports not (inset: 0px) {' +
      '[style*="inset: 0"],[style*="inset:0"]{top:0 !important;right:0 !important;bottom:0 !important;left:0 !important;}' +
    '}' +
    '@supports not (height: 1svh) {' +
      'div[style*="aspect-ratio: 1;"]::before,div[style*="aspect-ratio:1;"]::before,div[style*="aspect-ratio: 1 /"]::before,div[style*="aspect-ratio:1 /"]::before{content:"";display:block;padding-top:100%;}' +
      'div[style*="aspect-ratio: 16 / 9"]::before,div[style*="aspect-ratio:16 / 9"]::before{content:"";display:block;padding-top:56.25%;}' +
      'div[style*="aspect-ratio: 16 / 10"]::before,div[style*="aspect-ratio:16 / 10"]::before{content:"";display:block;padding-top:62.5%;}' +
      'div[style*="aspect-ratio: 3 / 4"]::before,div[style*="aspect-ratio:3 / 4"]::before{content:"";display:block;padding-top:133.33%;}' +
      'div[style*="aspect-ratio:"]{position:relative !important;}' +
      'div[style*="aspect-ratio:"] > img,div[style*="aspect-ratio:"] > video{position:absolute !important;top:0 !important;left:0 !important;width:100% !important;height:100% !important;object-fit:cover !important;}' +
      'img[style*="aspect-ratio:"]{height:auto !important;}' +
    '}' +
    '@supports not (aspect-ratio: 1 / 1) {' +
      'div[style*="aspect-ratio: 1;"]::before,div[style*="aspect-ratio:1;"]::before,div[style*="aspect-ratio: 1 /"]::before,div[style*="aspect-ratio:1 /"]::before{content:"";display:block;padding-top:100%;}' +
      'div[style*="aspect-ratio: 16 / 9"]::before,div[style*="aspect-ratio:16 / 9"]::before{content:"";display:block;padding-top:56.25%;}' +
      'div[style*="aspect-ratio: 16 / 10"]::before,div[style*="aspect-ratio:16 / 10"]::before{content:"";display:block;padding-top:62.5%;}' +
      'div[style*="aspect-ratio: 3 / 4"]::before,div[style*="aspect-ratio:3 / 4"]::before{content:"";display:block;padding-top:133.33%;}' +
      'div[style*="aspect-ratio:"]{position:relative !important;}' +
      'div[style*="aspect-ratio:"] > img,div[style*="aspect-ratio:"] > video{position:absolute !important;top:0 !important;left:0 !important;width:100% !important;height:100% !important;object-fit:cover !important;}' +
      'img[style*="aspect-ratio:"]{height:auto !important;}' +
    '}';
  document.head.appendChild(st);
})();

// ---- product page: load the Difference section injector ----
(function () {
  function go() {
    if (!document.getElementById('seq-wrap')) return;
    if (!window.CV || !CV.motion) return;
    var src = CV.motion.split('?')[0].replace('cv-pdp-motion.js', 'cv-diff.js') + '?v=3';
    var sc = document.createElement('script');
    sc.src = src;
    document.head.appendChild(sc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

// ---- mobile home: lift the hero Shop button (visual only, no layout impact) ----
(function () {
  var st = document.createElement('style');
  st.textContent = '@media (max-width: 640px){ #hero-cta{ transform: translateY(-120px); } }';
  document.head.appendChild(st);
})();
